import { render, staticRenderFns } from "./answeringDialog.vue?vue&type=template&id=5a7b7f12&scoped=true"
import script from "./answeringDialog.vue?vue&type=script&lang=js"
export * from "./answeringDialog.vue?vue&type=script&lang=js"
import style0 from "./answeringDialog.vue?vue&type=style&index=0&id=5a7b7f12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7b7f12",
  null
  
)

export default component.exports